import { render, staticRenderFns } from "./PrizeReport.vue?vue&type=template&id=2d2b2402&scoped=true"
import script from "./PrizeReport.vue?vue&type=script&lang=js"
export * from "./PrizeReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d2b2402",
  null
  
)

export default component.exports